<template>

  <div id="public-head">
    <!-- 头部区域 -->
    <header v-if="topImgUrl" class="top_heads" :style="{'backgroundImage':'url('+topImgUrl+')'}">
      <!-- <span class="back fl">
            </span> -->
      <template v-if="isGteatChefbrowser">
        <router-link to="/index2019?goback=1" class="back fl" />
        <span class="share fr" @click="shareLinkFn" />
      </template>

      <template v-if="desc">
        <div class="explain" @touchstart="show">
          <span class="explain-log " />
          <span class="explain-title">榜单说明 </span>
        </div>
        <div v-show="infosShow" class="infos" @click="infosShow = false" v-html="desc" />
      </template>
    </header>
    <header v-else class="noHeader">
      <template v-if="isGteatChefbrowser">
        <!-- <router-link to="/index2019" class="back fl"></router-link> -->
        <span class="share fr" @click="shareLinkFn" />
      </template>
    </header>

    <input id="shareImg" type="hidden" value="https://img.mingchu.co/ueditor/php/upload/image/20200119/1579429167875371.jpg">
    <input id="shareLink" v-model="shareInfo.shareLink" type="hidden">
    <input id="shareTitle" v-model="shareInfo.shareTitle" type="hidden">
    <input id="shareDesc" v-model="shareInfo.shareDesc" type="hidden">
  </div>
</template>
<script>

import { ajaxHttp } from '@/api/api'
import utils from '@/utils/utils'
import config from '@/config/config'

export default {
  name: 'Test',
  props: {
    topImgUrl: {
      type: String,
      default: ''

    },
    desc: {
      type: String,
      default: ''
    },
    shareInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      infosShow: false,
      isGteatChefbrowser: false // 判断浏览器内外

    }
  },
  created() {

  },
  beforeMount() {
    if (utils.isGteatChefbrowser()) {
      console.log('是在app内访问')
      this.isGteatChefbrowser = true
    } else {
      console.log('不是在app内访问')
      // this.isGteatChefbrowser = true
    }
  },
  mounted() {

  },
  methods: {
    callShareTop2019() {
      try {
        dsBridge.call('callShareTop2019',
          'http://greatchefupload.oss-cn-beijing.aliyuncs.com/Nuploads/ranking2020/zwNewTest/share/user/100114.jpg',
          function(result) {
            // alert(result);
          })
      } catch (e) {
        // alert(e)
      }
    },
    shareLinkFn() {
      dsBridge.call('CallLocalShare', null)
    },
    show() {
      if (!this.desc) {
        return
      }
      // this.infosShow =!this.infosShow;
      this.infosShow = true
    },
    hide() {
      if (!this.desc) {
        return
      }
      this.infosShow = false
    }

  }
}
</script>

<style scoped lang="scss">
    @import "../../style/scss/public.scss";

    #public-head {
        .top_heads{
            width: 100%;
            height: rem(400);
            background: center center no-repeat;
            background-size: 100% rem(400);
            position: relative;
        }
        .noHeader{
            display: flex;
            width: 100%;
            justify-content: flex-end;
            position: absolute;
            top: 10%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            .share,.back{
            margin-top: 0;

            }
        }
        header{

            /* margin-bottom: rem(48); */
            .back,
            .share {
                width: rem(56);
                height: rem(56);
                background: url("/webAssets/images/cookList/icon_share.png") no-repeat center;
                background-size: 100% 100%;
                border-radius: rem(28);
            }
            .back{
                background: url("/webAssets/images/cookList/icon_back.png") no-repeat center;
                background-size: 100% 100%;
            }
            .share{
                background: url("/webAssets/images/cookList/icon_share.png") no-repeat center;
                background-size: 100% 100%;
            }

            .back {
                margin-left: rem(24);
                margin-top: rem(62);
            }

            .share {
                margin-right: rem(24);
                margin-top: rem(62);
            }

            .explain {
                height: rem(28);
                position: absolute;
                left: rem(42);
                bottom: rem(36);

                .explain-log {
                    display: inline-block;
                    width: rem(20);
                    height: rem(20);
                    background: rgba(255, 255, 255, 1);
                    background: url("/webAssets/images/cookList/brandList/ranklist_help.png") center center no-repeat;
                    background-size: 100%;
                    margin-right: rem(10);

                }

                .explain-title {
                    display: inline-block;
                    height: rem(28);
                    font-size: rem(20);
                    font-family: PingFangTC-Regular, PingFangTC;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: rem(28);
                    /* position: absolute;
                left: rem(68);
                bottom: rem(34); */
                }
            }

            .infos {
                width: rem(360);
                background: rgba(0, 0, 0, 0.6);
                font-size: rem(20);
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                line-height: rem(28);
                position: absolute;
                padding: rem(16) rem(18);
                /* box-sizing: border-box; */
                top: rem(388);
                left: rem(32);
                z-index: 999;

            }
        }
    }
</style>
